export default {
  common: {
    loading: '加载中...',
    loadFail: '加载失败',
    noMore: '没有更多了',
    reset: '重置',
    confirm: '确认',
    cancel: '取消',
    yes: '是',
    no: '否',
  },
  notice: {
    title: '公告',
    searchPlaceholder: '请输入公告标题',
    search: '搜索',
    noMore: '没有更多了',
    read: '已读',
    unread: '未读',
    edit: '编辑',
    detail: '详情',
    readCount: '{n} 人已读',
  },
  rental: {
    topBarTitle: '出租房展示',
    title: '出租房源',
    publish: '发布房源',
    sortDefault: '综合排序',
    sortPrice: '价格排序',
    sortTime: '时间排序',
    sortLabel: '排序',
    filterLabel: '筛选',
    filterAll: '全部',
    sortSheetTitle: '排序方式',
    filterSheetTitle: '筛选',
    roomTypeTitle: '房型',
    facilityTitle: '房间设施',
    tagTitle: '标签',
    collapse: '收起',
    clear: '清空',
    confirm: '确定',
    callPhone: '手机联系',
    fiveStar: '五星房东',
    newListing: '最新发布',
    buildingUnit: '幢',
    priceFrom: '¥{price}起',
    priceRange: '¥{min} - ¥{max}',
    mr: '{surname}先生',
    ms: '{surname}女士',
  },
  tenantRating: {
    title: '评价房源',
    livingExperience: '居住体验',
    cleanliness: '安全管理',
    serviceAttitude: '服务态度',
    submitReview: '提交评价',
    poor: '差劲',
    needsImprovement: '需要改进',
    satisfied: '基本满意',
    veryGood: '非常好',
    excellent: '棒极了',
    missingProperty: '房源信息缺失',
    submitting: '提交中...',
    submitSuccess: '提交成功',
    submitFail: '提交失败',
  },
  rentalDetail: {
    monthlyRent: '月租金',
    description: '房源说明',
    facilities: '房间设施',
    photos: '房屋实拍',
    perMonth: '/月',
  },
  saveCode: {
    pageTitle: '房东网格',
    login: '登录',
    selfRegister: '自主登记',
    guestRegister: '租客登记',
    staffInfo: '三员信息',
    notice: '公告',
    checkInNotice: '入住须知',
    clickToView: '点击查看租房须知条款',
    verifyPhone: '联系电话',
    verifyCode: '短信验证码',
    sendCode: '发送验证码',
    verifyPlaceholder: '请输入联系电话',
    codePlaceholder: '请输入验证码',
    quickReport: '随手报',
    quickReportDesc: '社区问题随手拍，即刻反馈马上办',
    selfCheck: '自主整改',
    selfCheckDesc: '巡查问题自主办，整改到位不拖延',
    needHelp: '我要求助',
    needHelpDesc: '消防求助一键达，极速救援护平安',
    safetyPromo: '平安宣传',
    safetyPromoDesc: '今日安全提醒~',
    viewAll: '全部',
    cancel: '取消',
    confirm: '确定',
  },
  newRegister: {
    step1: '1. 选择户籍性质',
    step2: '2. 进行自主登记',
    householdType: '户籍性质',
    multiSelect: '（多选）',
    iHaveReadAndAgree: '我已阅读并同意',
    checkInNotice: '《入住须知》',
    pleaseRead: '（请阅读 {n} 秒）',
    next: '下一步',
    checkInNoticeTitle: '入住须知',
    pleaseAgreeNotice: '请先同意入住须知',
    pleaseSelectHouseholdType: '请选择户籍性质',
    localTenant: '我是本市户口租客',
    nonLocalTenant: '我是非本市户口租客',
    foreignNational: '我是境外人员',
    scanHint: '扫描身份证件可自动生成个人信息',
    scanPassportHint: '扫描护照可自动生成个人信息',
    uploadPhoto: '上传照片',
    clickToUpload: '点击上传',
    residenceInfo: '居住信息',
    rentalInfo: '租赁信息',
    tagInfo: '标签信息',
    submit: '提交',
    selectBirthday: '选择出生日期',
    selectDate: '选择年月日',
    pleaseSelect: '请选择',
    idNumberTypeRequired: '请选择证件类型',
    idNumberValid: '请输入有效证件号',
    idNumberRequired: '请输入证件号',
    nameRequired: '请输入姓名',
    sexRequired: '请选择性别',
    mobileInvalid: '请输入正确的手机号码',
    nationalityRequired: '请选择国籍',
    nationRequired: '请选择民族',
    birthdayRequired: '请选择出生日期',
    regAddressRequired: '请填写户籍地址',
    houseRequired: '请选择居住房屋',
    relationshipRequired: '请选择与房主关系',
    roomRequired: '请填写隔间房号',
    nowAddressRequired: '请填写现居住地',
    rentStartRequired: '请选择租赁开始时间',
    rentEndRequired: '请选择租赁结束时间',
    sameTimeError: '请勿选择相同时间',
    startEndError: '租赁开始时间不能大于或等于结束时间',
    confirmSubmit: '确认提交？',
    submitSuccess: '操作成功',
    submitAudit: '居民信息已提交审核',
    saveSuccess: '保存成功',
    tenantSelfRegister: '租客自主登记',
    tenant: '租客',
    idCard: '身份证',
    passport: '护照',
    hkMacaoTaiwan: '港澳台证件',
    policeCard: '警官证',
    militaryCard: '军官证',
    otherCertificate: '其他证件',
    noCertificate: '无证件',
    registerSuccess: '登记成功',
    registerTime: '登记时间：',
    idNumberTypeLabel: '证件类型',
    idNumberTypePlaceholder: '点击选择证件类型',
    idNumberLabel: '证件号',
    idNumberPlaceholder: '请输入有效证件号',
    idNumberPlaceholderOther: '请输入证件号',
    nameLabel: '姓名',
    namePlaceholder: '请输入姓名',
    sexLabel: '性别',
    sexPlaceholder: '请选择性别',
    sexMale: '男',
    sexFemale: '女',
    mobileLabel: '手机号码',
    mobilePlaceholder: '请输入手机号码',
    nationalityLabel: '国籍',
    nationalityPlaceholder: '请选择国籍',
    nationLabel: '民族',
    nationPlaceholder: '请选择民族',
    nativePlaceLabel: '籍贯',
    nativePlacePlaceholder: '请选择籍贯',
    birthdayLabel: '出生日期',
    birthdayPlaceholder: '请选择出生日期',
    companyLabel: '工作单位',
    companyPlaceholder: '请输入工作单位',
    emContactLabel: '紧急联系人',
    emContactPlaceholder: '请输入紧急联系人',
    emMobileLabel: '联系人手机号',
    emMobilePlaceholder: '请输入联系人手机号',
    regAddressLabel: '户籍地址',
    regAddressPlaceholder: '请输入户籍地址',
    houseLabel: '居住房屋',
    housePlaceholder: '请选择居住房屋',
    relationshipLabel: '与房主关系',
    relationshipPlaceholder: '请选择与房主关系',
    roomLabel: '隔间房号',
    roomPlaceholder: '示例：1号房',
    nowAddressLabel: '现居住地',
    nowAddressPlaceholder: '请输入现居住地',
    moveInDateLabel: '入住时间',
    moveInDatePlaceholder: '请选择入住时间',
    rentStartLabel: '租赁开始时间',
    rentStartPlaceholder: '请选择租赁开始时间',
    rentEndLabel: '租赁结束时间',
    rentEndPlaceholder: '请选择租赁结束时间',
    partyMember: '党员',
    veteran: '退役军人',
    disabled: '残疾人',
    retire: '退休人员'
  },
  nation: {
    searchPlaceholder: '请输入国家/地区名称',
    noResult: '无匹配结果',
  },
  activity: {
    title: '活动',
    all: '全部活动',
    signed: '已报名活动',
    search: '搜索',
    searchPh: '请输入活动标题',
    type: '活动类型',
    startDate: '开始时间',
    endDate: '结束时间',
    datePick: '选择年月日',
    noMore: '没有更多了',
    totalCount: '共有 {n} 条数据',
    unlimited: '不限',
    capacity: '活动人数：',
    signCount: '报名人数：',
    remaining: '剩余：',
    noSign: '无需报名',
    deadline: '报名截止',
    signedIn: '已签到',
    signedUp: '已报名',
    signEnded: '报名已结束',
    inProgress: '活动进行中',
    ended: '活动已结束',
    time: '活动时间：',
    to: ' 至 ',
    peopleUnit: '人',
    activitySuffix: '活动',
    detail: '活动详情',
    notice: '活动须知',
    location: '活动地点：',
    deadlineTime: '报名截止时间：',
    signUp: '报名',
    cancelSign: '取消报名',
    signingUp: '报名中...',
    signUpOk: '报名成功',
    confirmCancel: '请确认是否取消报名',
    cancelOk: '取消成功',
    signInOk: '本次活动您已签到成功！',
    typeLoadFail: '活动类型获取失败',
    startAfterEnd: '开始时间不能比结束时间大哦',
    endBeforeStart: '结束时间不能比开始时间小哦',
    resident: '居民',
    socialWorker: '社工/村委',
    ms: '女士',
    mr: '先生',
  },
};
